<template>
  <div id="faces">
    <div v-if="isLoggedIn">
      <div id="search" class="inline fields">
        <div class="ui large label">Filter: </div>
        <div class="field">
          <input id="searchbox" type="text" v-model="filtertext" placeholder="e.g. Joe Smith"/>
        </div>
      </div>
      <div v-if="filteredFaces && filteredFaces.length" class="faces-list">
        <div v-for="face of filteredFaces" class="faces-list-entry" v-bind:key="face.frontend_face_uuid">

          <div class="faces-list-entry-info">
            <div class="person-title">{{face.person_name}}</div>
            <div v-if="face.employee">
              <strong>Employee</strong>
            </div>
            <div v-if="face.resident">
              <strong>Resident</strong>
            </div>
            <div v-if="face.wing || face.room">
              <strong>Wing/Room:</strong>&nbsp;{{face.wing ? face.wing + ', ' : ''}}Room {{face.room}}
            </div>
            <div v-if="face.wanderguard">
              <strong>WanderGuard:</strong>
              {{face.wanderguard}}
            </div>
            <router-link v-if="face.images_tagged" v-bind:to="'/confirmed/' + face.frontend_face_uuid">
              {{face.images_tagged}} image{{face.images_tagged > 1 ? 's' : ''}} tagged
            </router-link>
            <div class="search">
              <router-link v-bind:to="'/detected/' + face.frontend_face_uuid" class="ui button small">Search</router-link>
            </div>
          </div>
          <div class="face-image-area" v-if="face.images && face.images.length">
            <div v-for="image of face.images" class="face-image-div" v-bind:key="image.thumbnail_uri">
              <!-- <img v-bind:src="image.uri" class="face-image" height="160px"></img> -->
              <img v-lazy="image.thumbnail_uri" class="face-image" height="160px"></img>
              <br/>
              {{image.orientation}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      To start, please <router-link to="/login">log in</router-link>.
    </div>
  </div>
</template>

<script>

import {mapGetters} from 'vuex';

export default {
  name: 'faces',
  data: function() {
    return {
      filtertext: '',
    }
  },
  created() {
    this.filtertext = this.$route.params.person_name
  },
  computed: {
    filteredFaces() {
      if (!this.filtertext) return this.frontendFaces;
      return this.frontendFaces.filter(face => {
        if (face.person_name.toLowerCase().includes(this.filtertext.toLowerCase())) return true;
        if (face.role && face.role.toLowerCase().startsWith(this.filtertext.toLowerCase())) return true;
        if (face.room && face.room.toLowerCase().includes(this.filtertext.toLowerCase())) return true;
      })
    },
    ...mapGetters(['frontendFaces', 'isLoggedIn'])
  }
}
</script>

<style scoped>

.faces-list {
  background-color: white;
  padding: 20px;
}

.faces-list-entry {
  /* border: 1px solid black; */
  margin: 10px 10px 10px 10px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.faces-list-entry-info {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: left;
  /* border: 1px dashed blue; */
}

.face-image-area {
  display: flex;
  flex-direction: row;
  margin: 0px;
}

.face-image-div {
  /* display: flex;
  flex-direction: column; */
  padding: 5px;
  width: 250px;
}

.face-image {
  /* border: 1px solid black; */
}

.person-title {
  font-size: x-large;
}

img {
    image-orientation: from-image;
}

#search {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>


// WEBPACK FOOTER //
// Faces.vue?272cd56a